import url from "url/index";
import { SEO } from "utils/helmet/components/SEO";
import GameHistoryContainer from "containers/organisms/GameHistoryContainer";
import { useNavigate } from "react-router-dom";
import PageTitle from "components/atoms/PageTitle";
import classNames from "classnames";
import { useRef } from "react";
import { useBreakpoint } from "../../../../hooks/useBreakpoint";
import useScrollDetection from "../../../../hooks/useScrollDetection";

import "./styles.sass";

const GameHistoryPage = () => {
  const navigate = useNavigate();
  const { isDesktop } = useBreakpoint();
  const scrollRef = useRef<HTMLDivElement>(null);
  const isScrolled = useScrollDetection(scrollRef);

  const handleBack = () => {
    navigate({
      ...(!isDesktop && {
        pathname: url.routes.profile.index(),
      }),
    });
  };

  const GameHistoryPageHeader = classNames("GameHistoryPage__header", {
    border: isScrolled,
  });

  return (
    <>
      <SEO
        pathname={`/${url.config.profile.root}/${url.config.profile.gamesHistory}`}
      />
      <div
        className="GameHistoryPage"
        style={{ overflowY: "auto", maxHeight: "100vh" }}
        ref={scrollRef}
      >
        <div className={GameHistoryPageHeader}>
          <PageTitle
            title="profile.navigation.games"
            {...(!isDesktop ? { onBack: handleBack } : {})}
          />
        </div>
        <GameHistoryContainer />
      </div>
    </>
  );
};

export default GameHistoryPage;
